"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ComponentTypes = require("./ComponentTypes");
var Grid_1 = require("./Grid");
var applyLayout = mobx_1.action(function (dashboard) {
    var windows = dashboard.windows;
    var grid = new Grid_1.Grid();
    dashboard.setComponent(grid);
    windows.forEach(function (w) { return grid.add(w); });
});
exports.applyLayout = applyLayout;
var isLayoutApplied = function (dashboard) {
    return dashboard.component && dashboard.component.type === ComponentTypes.grid;
};
exports.isLayoutApplied = isLayoutApplied;
